import { Link } from 'react-router-dom';
import './App.css';
import { FaCheck,FaGithub } from "react-icons/fa6";
import { RiVideoOnAiFill } from "react-icons/ri";
import { IoKeyOutline,IoEarthSharp } from "react-icons/io5";
import { useState } from 'react';
import Model from './Components/Model';
import { motion } from "motion/react";

const projects = [
  { 
    image:'./Images/E-commerce.png',
    title: 'E-commerce Store',
    type: 'React + Laravel API + Bootstrap + Framer Motion',
    description:
      'I developed a comprehensive e-commerce application featuring a responsive frontend built with React and integrated with APIs built using Laravel.',
    KeyFeatures:[
      "Role-Based Authentication",
      "Admin Dashboard",
      "Order Management",
      "Customer Request Tracking",
      "Admin Reply System",
      "Responsive Design"
    ],
    links:[
      {
        title:'Live Demo',
        url:'https://smooth-picks.duckdns.org/',
        icon:<IoEarthSharp color='#22C55E' />
      },
      {
        title:'Watch Demo',
        url:'https://www.youtube.com/watch?v=qI_opdamChM',
        icon:<RiVideoOnAiFill color='#EF4444' />
      },
      {
        title:'Demo Credentials',
        url:'https://www.youtube.com/watch?v=qI_opdamChM',
        icon:<IoKeyOutline color='#c4e91f' />
      },
         {
        title:'GitHub',
        url:'https://github.com/Ali-Hasan-developer/E-commerce-front-end.git',
        icon:<FaGithub color='#000000' />
      }
    ],
    delay:0.2,
  },
  {
     image:'./Images/Arbeito.png',
    title: 'Corporate Website UI',
    type: 'React + Bootstrap + Framer Motion',
    description:
      'Developed a modern corporate website interface using React, Bootstrap, and Framer Motion, with a strong focus on responsive design, reusable components and smooth animations.',
    KeyFeatures:[
      "Responsive Design",
      "Smooth Framer Motion Animations",
      "Reusable React Components",
      "Modern Corporate UI",
      "Interactive User Experience",
      "Clean & Maintainable Code"
    ],
     links:[
      {
        title:'Live Demo',
        url:'https://modern-react-app-dev.netlify.app',
        icon:<IoEarthSharp color='#22C55E' />
      },
        {
        title:'GitHub',
        url:'https://github.com/Ali-Hasan-developer/React-frontend.git',
        icon:<FaGithub color='#000000' />
      }
    ],
    delay:1
  },
];
const cardInfo={
   cardTitle:'Demo Account',
    cardDescription:'Explore the application using the credentials below.',
    cardEmail:'Email: demo.account@gmail.com',
    cardPassWord:'Password: smooth@123',
    cardNote:'The demo account has fewer administrative privileges than the admin account.User management and role assignment have been disabled.'
  }

export default function FeaturedProjects() {
  //State for show model
  const [show, setShow] = useState(false);
  //Mapping
  const projectsShow=projects.map((project,key) => (
          <motion.div className="project-card" key={key}
          initial={{ opacity: 0 ,translateY: "60px" }}
          whileInView={{ opacity: 1 ,translateY: 0 }}
            whileHover={{ scale: 1.03}}
          transition={{
            opacity:{
                  duration:1, delay:project.delay
              },
              translateY:{
                  duration:1, delay:project.delay
              },
              scale:{
                duration:0.2, delay:0
              }
        }}
          viewport={{once:true}}>
            <img style={{width:'100%',height:'300px',borderRadius:'10px'}} src={require(`${project.image}`)}/>
            <h3 style={{marginTop:'16px'}}>{project.title}</h3>
            <div className="meta">{project.type}</div>
            <p className="section-text">{project.description}</p>
            <ul style={{listStyle:'none'}}>
              {project.KeyFeatures.map((item)=>
                <li><FaCheck color='#38BDF8'/> {item}</li>
              )}
            </ul>
            <div className='demo-parent d-flex flex-wrap justify-content-start gap-3'>
              {project.links.map((item)=>
                item.title==='Demo Credentials'?
                <div className='btn btn-secondary' onClick={()=>setShow(true)}>{item.icon} {item.title}</div>:
                <a className='btn btn-secondary d-flex gap-1' 
                target="_blank"
                 href={item.url}>
                  {item.icon} {item.title}</a>
              )}
            </div>
            <Model show={show} setShow={setShow} title={cardInfo.cardTitle} note={cardInfo.cardNote}
            description={cardInfo.cardDescription} email={cardInfo.cardEmail} password={cardInfo.cardPassWord}/>
          </motion.div>
        ))
  return (
    <section id="featured-projects" className="section">
      <div className="section-heading">
        <h2>Featured Projects</h2>
        <p>Selected work that reflects my approach to front-end development :</p>
      </div>
      <div className="projects-grid">
        {projectsShow}
      </div>
    </section>
  );
}

